export default "__VITE_ASSET__BibYPuY7__"